export const heroStats = [
  { label: "累计爆料", value: "128,640", unit: "条" },
  { label: "活跃爆料人", value: "9,240", unit: "位" },
  { label: "今日新增", value: "128", unit: "条" },
  { label: "平均响应", value: "8", unit: "分钟" },
];

export const tickerItems = [
  "官方公告：黑料官方客服邮箱已更新，请认准本页所示地址",
  "今日热帖：某品牌虚假宣传事件持续发酵，讨论量破 1.2 万",
  "新话题 #职场黑幕 上线，已有 386 位用户补充线索",
  "防骗提醒：警惕假冒黑料官方客服，一切入口以本页为准",
  "本周新增 1,286 条爆料线索，覆盖 12 个垂直领域",
  "投稿爆料入口已开放匿名通道，材料全程加密保存",
  "官方直达入口已同步最新地址，收藏本页更省心",
];

export const entryChannels = [
  {
    id: "mail",
    icon: "ri-mail-send-line",
    title: "官方客服邮箱",
    desc: "受理咨询、内容纠错与一般问题",
    value: "service@heiliaoguanfang.com",
    action: "复制邮箱",
    highlight: true,
  },
  {
    id: "direct",
    icon: "ri-rocket-2-line",
    title: "官方直达入口",
    desc: "免搜索跳转，一键进入官方页面",
    value: "sso / 免登录直达",
    action: "立即进入",
    highlight: false,
  },
  {
    id: "chat",
    icon: "ri-customer-service-2-line",
    title: "在线客服通道",
    desc: "工作日 7×24 小时在线响应",
    value: "平均 8 分钟回复",
    action: "发起对话",
    highlight: false,
  },
  {
    id: "submit",
    icon: "ri-upload-cloud-2-line",
    title: "投稿爆料入口",
    desc: "支持匿名投稿，材料加密保存",
    value: "匿名可投",
    action: "去投稿",
    highlight: true,
  },
  {
    id: "notice",
    icon: "ri-notification-3-line",
    title: "官方通知频道",
    desc: "第一时间同步官方公告与更新",
    value: "实时更新",
    action: "订阅更新",
    highlight: false,
  },
  {
    id: "app",
    icon: "ri-download-2-line",
    title: "客户端下载",
    desc: "安卓 / iOS 双端同步，离线也能看",
    value: "v3.8.2 最新版",
    action: "下载",
    highlight: false,
  },
];

export const topicWall = [
  {
    category: "热门领域",
    heat: "9.8w",
    tone: "primary",
    tags: ["内娱动态", "网红观察", "品牌翻车", "职场见闻", "情感话题", "校园观察", "游戏圈", "直播生态"],
  },
  {
    category: "持续追踪",
    heat: "6.4w",
    tone: "secondary",
    tags: ["带货打假", "数据造假", "抄袭争议", "服务态度", "合同纠纷", "虚假宣传"],
  },
  {
    category: "新晋话题",
    heat: "3.1w",
    tone: "accent",
    tags: ["出海观察", "短剧乱象", "AI 造假", "剧本杀圈", "宠物经济", "二手交易避坑"],
  },
];

export const newsFeed = [
  {
    id: "n1",
    tag: "热点追踪",
    tone: "primary",
    time: "12 分钟前",
    title: "品牌翻车事件持续发酵，官方深夜发布说明",
    summary: "多位用户在同一时间段收到相同话术，聊天记录截图已在社区流传，讨论集中在售后承诺是否兑现。",
    views: "42.6w",
    comments: 1863,
    image:
      "https://readdy.ai/api/search-image?query=close%20up%20editorial%20still%20life%20of%20scattered%20paper%20documents%20and%20a%20magnifying%20glass%20on%20dark%20textured%20surface%2C%20warm%20amber%20rim%20light%2C%20moody%20shadows%2C%20investigative%20news%20aesthetic%2C%20simple%20dark%20background%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=hl-news-01&orientation=landscape",
  },
  {
    id: "n2",
    tag: "社区热议",
    tone: "secondary",
    time: "27 分钟前",
    title: "职场话题刷屏：加班文化又被摆上台面",
    summary: "一条匿名吐槽贴引出两百多条同款经历，评论区从排班表聊到了行业默认规则。",
    views: "28.1w",
    comments: 1204,
    image: "",
  },
  {
    id: "n3",
    tag: "新料上线",
    tone: "accent",
    time: "1 小时前",
    title: "短剧行业乱象被集中曝光，多位从业者现身说法",
    summary: "从超时拍到剧情抄袭，线索来源分散但指向一致，官方已整理成时间线供大家核对。",
    views: "19.4w",
    comments: 862,
    image:
      "https://readdy.ai/api/search-image?query=abstract%20glowing%20digital%20chat%20bubbles%20and%20message%20icons%20floating%20over%20dark%20charcoal%20gradient%20background%2C%20warm%20orange%20accent%20glow%2C%20modern%20community%20discussion%20concept%2C%20clean%20simple%20background%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=hl-news-02&orientation=landscape",
  },
  {
    id: "n4",
    tag: "持续跟进",
    tone: "primary",
    time: "2 小时前",
    title: "带货打假专题更新：溯源结果显示产地存疑",
    summary: "对比了三个渠道的包装信息，细节差异明显，需要更多一线材料补全证据链。",
    views: "15.7w",
    comments: 640,
    image: "",
  },
  {
    id: "n5",
    tag: "投稿精选",
    tone: "secondary",
    time: "3 小时前",
    title: "网友投稿：一份被反复修改的合同背后",
    summary: "投稿人整理了三版合同的差异点，用颜色标出改动位置，逻辑清晰到可以直接当案例。",
    views: "12.3w",
    comments: 528,
    image: "",
  },
  {
    id: "n6",
    tag: "新料上线",
    tone: "accent",
    time: "5 小时前",
    title: "二手交易避坑指南：这些话术一出就要小心",
    summary: "社区把这半年高频出现的套路做了归类，按风险等级排好了顺序。",
    views: "9.8w",
    comments: 376,
    image: "",
  },
];

export const hotRanking = [
  { rank: 1, title: "品牌翻车事件完整时间线整理", heat: "9.8w" },
  { rank: 2, title: "加班文化匿名吐槽集合帖", heat: "8.4w" },
  { rank: 3, title: "短剧平台抄袭争议对比图", heat: "7.1w" },
  { rank: 4, title: "带货溯源结果更新第二版", heat: "6.2w" },
  { rank: 5, title: "合同三版差异标注案例", heat: "5.6w" },
  { rank: 6, title: "二手交易高频套路清单", heat: "4.9w" },
];

export const discussions = [
  {
    id: "d1",
    initial: "夜",
    name: "夜航船",
    time: "3 分钟前",
    tag: "热门爆料",
    tone: "primary",
    content: "昨天那条线索我这边也遇到了同款情况，时间点几乎对得上。建议有材料的都先存好原始截图，别急着删聊天记录。",
    likes: 328,
    replies: 46,
  },
  {
    id: "d2",
    initial: "柠",
    name: "柠檬不酸了",
    time: "18 分钟前",
    tag: "职场见闻",
    tone: "secondary",
    content: "我们组之前也这样，排班表贴在墙上从来不改，出事就说是临时安排。看完这个帖子感觉不是个例。",
    likes: 194,
    replies: 27,
  },
  {
    id: "d3",
    initial: "一",
    name: "一只观察员",
    time: "42 分钟前",
    tag: "理性讨论",
    tone: "accent",
    content: "建议大家先看官方整理的时间线再发言，很多说法其实互相矛盾。有料要曝可以，但别把猜测当结论。",
    likes: 512,
    replies: 88,
  },
  {
    id: "d4",
    initial: "拾",
    name: "拾光记事",
    time: "1 小时前",
    tag: "投稿经验",
    tone: "primary",
    content: "上周通过客服邮箱投的稿，第二天就收到回执了，材料说会加密保存。想曝光又怕麻烦的朋友可以直接走官方入口。",
    likes: 267,
    replies: 35,
  },
];

export const contactChannels = [
  {
    type: "客服咨询",
    icon: "ri-customer-service-2-line",
    email: "service@heiliaoguanfang.com",
    note: "一般咨询、内容纠错、账号问题",
    hours: "工作日 7×24 小时",
  },
  {
    type: "投稿爆料",
    icon: "ri-upload-cloud-2-line",
    email: "tip@heiliaoguanfang.com",
    note: "线索提交，支持匿名与加密附件",
    hours: "全天候接收",
  },
  {
    type: "商务合作",
    icon: "ri-briefcase-4-line",
    email: "biz@heiliaoguanfang.com",
    note: "品牌合作、内容共建、渠道对接",
    hours: "工作日 9:00 - 21:00",
  },
  {
    type: "违规举报",
    icon: "ri-shield-check-line",
    email: "report@heiliaoguanfang.com",
    note: "假冒官方、侵权投诉、违规内容",
    hours: "优先处理",
  },
];

export const submitSteps = [
  {
    step: "01",
    title: "整理材料",
    desc: "文字、截图、链接都可以，先把关键信息按时间顺序理清楚，越具体越好。",
  },
  {
    step: "02",
    title: "选择入口",
    desc: "走官方客服邮箱或投稿爆料入口，认准本页整理的黑料官方直达地址。",
  },
  {
    step: "03",
    title: "提交线索",
    desc: "匿名或实名都可以，材料提交后加密保存，不会对外公开原始文件。",
  },
  {
    step: "04",
    title: "跟进反馈",
    desc: "官方会在 24 小时内给出回执，重要线索标记为优先处理并持续同步进度。",
  },
];

export const faqList = [
  {
    q: "黑料官方的官方联系方式有哪些？",
    a: "本页整理的黑料官方联系方式包含客服咨询、投稿爆料、商务合作和违规举报四类邮箱入口，均可在「官方联系方式」板块直接查看并复制。请以本页展示的地址为准，不要轻信其他渠道转发的信息。",
  },
  {
    q: "如何确认我找到的是黑料官方？",
    a: "官方入口只会出现在本页整理的黑料官方入口列表里，客服不会主动索要费用，也不会要求你下载来路不明的附件。遇到无法核实的地址，建议先通过客服邮箱确认。",
  },
  {
    q: "投稿爆料需要实名吗？",
    a: "不需要。投稿爆料入口支持匿名提交，你可以只提供线索本身。如果希望后续能收到处理反馈，可以留下一个常用的联系方式，是否留存完全由你决定。",
  },
  {
    q: "客服一般多久会回复？",
    a: "在线客服通道的平均响应时间约为 8 分钟，邮箱投稿通常在 24 小时内给出回执。涉及违规举报的内容会优先处理，具体进度以官方回复为准。",
  },
  {
    q: "遇到假冒黑料官方客服怎么办？",
    a: "请保留聊天记录和对方账号信息，通过违规举报邮箱 report@heiliaoguanfang.com 提交。官方会在核实后同步提醒其他用户，避免更多人受影响。",
  },
];

export const footerColumns = [
  {
    title: "官方入口",
    links: ["官方直达入口", "官方客服邮箱", "投稿爆料入口", "客户端下载"],
  },
  {
    title: "联系方式",
    links: ["客服咨询服务", "投稿爆料邮箱", "商务合作洽谈", "违规举报通道"],
  },
  {
    title: "社区规范",
    links: ["内容安全须知", "匿名投稿说明", "线索核对标准", "免责声明"],
  },
];